<template>
  <div class="container_box">
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003648')" prop="billingTime">
              <Date-picker
                type="month"
                class="wid100P"
                v-model="pageParams.billingTime"
                :clearable="true"
                format="yyyy-MM"
                placement="bottom-end"
                :placeholder="$t('key1000360')">
              </Date-picker>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003649')" prop="distributorMerchantId">
              <Input v-model.trim="pageParams.distributorMerchantId" :placeholder="$t('key1003650')" clearable></Input>
            </Form-item>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <!--导出数据-->
      <Dropdown transfer @on-click="changeExportBtn" v-if="getPermission('ymsBill_exportDistributorBill') ||
      getPermission('ymsBill_exportDistributorDetailBill')">
        <Button type="primary">
          <span>{{ $t('key1003082') }}</span>
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
          <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="selection"
        highlight-row
        border
        max-height="530"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData"
        @on-selection-change="tableChange">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--导出数据字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :dimensionTalg="true"
      :exportFieldsTitle="$t('key1003651')"
      paramKeyColums="ymsDistributorBillExportColumns"
      :customFieldExportList="customFieldExportList"
      :dimensionTypeList="dimensionTypeList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {EventBus, commonLocalStorage, pageJump, setConfigCharacters} from "@/utils/common";
import exportFieldsModal from "@/components/common/exportFieldsModal";

export default {
  name: "customerBill",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        billingTime: null,
        distributorMerchantId: '',
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          key: 'selection',
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003612'),
          key: 'billNo',
          align: 'left',
          minWidth: 160,
          render(h, params) {
            return h('Alink', {
              props: {
                linkName: params.row.billNo
              },
              on: {
                AlinkBtn: () => {
                  v.$router.push({
                    path: '/customerBillDetails',
                    query: {
                      ymsBillId: params.row.ymsBillId
                    }
                  });
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003613'),
          key: 'billMonth',
          minWidth: 120,
          align: 'left',
          render(h, params) {
            let date = '-';
            let billMonth = params.row.billMonth;
            if (billMonth) {
              let time = billMonth.split('-');
              date = `${time[0]}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000492')}${time[1]}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000493')}`;
            }
            return h('span', date);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003180'),
          key: 'businessMerchantName',
          minWidth: 120,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003614'),
          key: 'businessMerchantId',
          minWidth: 120,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003615'),
          key: 'rechargeTotal',
          minWidth: 150,
          align: 'left',
          render(h, params) {
            let currency = params.row.currency || v.currencyState;
            let platformRechargePrice = params.row.platformRechargePrice || 0;
            let handRechargePrice = params.row.handRechargePrice || 0;
            let rechargeTotal = platformRechargePrice + handRechargePrice;
            let text = v.formatCurrency(rechargeTotal);
            return h('span', text + ' ' + currency);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003616'),
          key: 'platformRechargePrice',
          minWidth: 150,
          align: 'left',
          render(h, params) {
            let currency = params.row.currency || v.currencyState;
            let text = v.formatCurrency(params.row.platformRechargePrice);
            return h('span', text + ' ' + currency);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003617'),
          key: 'handRechargePrice',
          minWidth: 140,
          align: 'left',
          render(h, params) {
            let currency = params.row.currency || v.currencyState;
            let text = v.formatCurrency(params.row.handRechargePrice);
            return h('span', text + ' ' + currency);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003618'),
          key: 'consumptionAmount',
          minWidth: 140,
          align: 'left',
          render(h, params) {
            let currency = params.row.currency || v.currencyState;
            let text = v.formatCurrency(params.row.consumptionAmount);
            return h('span', text + ' ' + currency);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003619'),
          key: 'updatedTime',
          minWidth: 170,
          align: 'left',
          render: (h, params) => {
            return h('div', v.$uDate.dealTime(params.row.updatedTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'action',
          align: 'center',
          width: 120,
          render: function (h, params) {
            let ymsBillId = params.row.ymsBillId;
            let billStatus = params.row.billStatus; // 1 生成中 2 生成失败 3 生成成功
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000337'),
                    show: billStatus !== 1,
                    clickFn: () => {
                      v.updateBillBtn(ymsBillId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      selectTableData: [],
      exportType: '1',
      customFieldExportList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003620'),
          titleKey: 'billingInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {type: [1, 2], paramKey: 'billNo', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003612')},
            {type: [1, 2], paramKey: 'billMonth', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003613')},
            {type: [1, 2], paramKey: 'businessMerchantName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003180')},
            {type: [1, 2], paramKey: 'businessMerchantMerchantId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003614')},
            {type: [1, 2], paramKey: 'totalRechargeAmount', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003615')},
            {type: [1, 2], paramKey: 'platformRechargePrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003616')},
            {type: [1, 2], paramKey: 'handRechargePrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003617')},
            {type: [1, 2], paramKey: 'consumptionAmount', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003618')},
            {type: [1, 2], paramKey: 'createdTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003619')}
          ]
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002931'),
          titleKey: 'rechargeRecordColums',
          selectList: [],
          checkBoxList: [
            {type: [2], paramKey: 'ymsDistributorMerchantId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003621')},
            {type: [2], paramKey: 'recordBillNo', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003622')},
            {type: [2], paramKey: 'ymsDistributorMerchantRechargeRecordId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003623')},
            {type: [2], paramKey: 'paymentSerialNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003624')},
            {type: [2], paramKey: 'rechargeAmount', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003625')},
            {type: [2], paramKey: 'paymentMethod', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003626')},
            {type: [2], paramKey: 'updatedTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003627')},
            {type: [2], paramKey: 'updatedBy', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000292')},
            {type: [2], paramKey: 'remarks', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000350')}
          ]
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003628'),
          titleKey: 'consumptionRecordsColums',
          selectList: [],
          checkBoxList: [
            {type: [2], paramKey: 'distributorMerchantId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003621')},
            {type: [2], paramKey: 'packageBillNo', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003622')},
            {type: [2], paramKey: 'packageCode', paramValue: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522')}`},
            {type: [2], paramKey: 'status', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002917')},
            {type: [2], paramKey: 'orderShippingId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003629')},
            {type: [2], paramKey: 'YMSSKU', paramValue: `${setConfigCharacters(false)}SKU`},
            {type: [2], paramKey: 'productQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003630')},
            {type: [2], paramKey: 'totalWeight', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003631')},
            {type: [2], paramKey: 'productCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003632')},
            {type: [2], paramKey: 'logisticsCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003633')},
            {type: [2], paramKey: 'actualLogisticsCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003634')},
            {type: [2], paramKey: 'prepayPackageHandlerCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003635')},
            {type: [2], paramKey: 'packageHandlerCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003636')},
            {type: [2], paramKey: 'returnedItemShippingCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003637')},
            {type: [2], paramKey: 'remoteAreasShippingCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003638')},
            {type: [2], paramKey: 'quadraticShippingCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003639')},
            {type: [2], paramKey: 'cancelShippingCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003640')},
            {type: [2], paramKey: 'totalPrice', paramValue: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003599')}`},
            {type: [2], paramKey: 'currency', paramValue: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003611')}`},
            {type: [2], paramKey: 'shipedTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003641')},
            {type: [2], paramKey: 'domesticExpressFeeCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003642')},
            {type: [2], paramKey: 'customsClearanceFeeCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003643')},
          ]
        }
      ]
    };
  },
  computed: {
    dimensionTypeList() {
      let list = [
        {value: 1, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003644'), permissionKey: 'ymsBill_exportDistributorBill'},
        {value: 2, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003645'), permissionKey: 'ymsBill_exportDistributorDetailBill'}
      ];
      list.map((item) => {
        item['show'] = this.getPermission(item.permissionKey);
      });
      return list;
    }
  },
  mounted() {
    EventBus.$on('initCustomerBillUpdateCompletedData', this.handleCustomerBillData);
    let obj = commonLocalStorage.getItem('customerBillQuery');
    if (obj) {
      this.handleCustomerBillData(obj);
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 处理参数
    handleCustomerBillData(data) {
      this.$Modal.remove();
      if (data) {
        this.pageParams.billingTime = data.billMonth;
        this.pageParams.distributorMerchantId = data.businessMerchantId;
        this.search();
      }
    },
    // 初始化接口数据
    initFun() {
      (async () => {
        await this.search();
      })();
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.getList();
    },
    // 重置按钮
    reset() {
      let v = this;
      v.selectTableData = [];
      v.$refs['pageParams'].resetFields();
      v.getList();
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      params.billingTime = v.pageParams.billingTime ? v.$uDate.getDateTime(v.pageParams.billingTime, 'month') : null;
      return params;
    },
    // 列表查询的方法
    getList() {
      let v = this;
      v.optionBtnWidth = [];
      v.selectTableData = [];
      v.tableData = [];
      v.total = 0;
      v.$nextTick(() => {
        if (v.$refs.selection && v.$refs.selection.selectAll) {
          v.$refs.selection.selectAll(false);
        }
      });
      if (v.getPermission('ymsBill_queryForDistributorBill')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsBill_queryForDistributorBill, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            commonLocalStorage.removeItem('customerBillQuery');
            if (data) {
              v.tableData = data.list || [];
              v.total = data.total;
              v.$nextTick(() => {
                v.tableLoading = false;
              });
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = [];
      if (data) {
        this.selectTableData = data.map((item) => {
          return item.ymsBillId;
        });
      }
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn() {
      let v = this;
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.ymsBillIds = v.selectTableData;
      } else {
        query.ymsBillIds = [];
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((data) => {
        if (data) {
          let dimensionType = data.dimensionType;
          let url = dimensionType === 1 ? api.post_ymsBill_exportDistributorBill : api.post_ymsBill_exportDistributorDetailBill;
          v.axios.post(url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/yms.html#/exportTask?operateCode=' + taskNumber, '/yms-core-service', '_blank');
              }, 30);
            }
          });
        }
      });
    },
    // 更新账单
    updateBillBtn(ymsBillId) {
      let v = this;
      v.axios.post(api.post_ymsBill_regenerateDistributorBill + ymsBillId).then(res => {
        if (res.data.code === 0) {
          v.$Modal.info({
            width: 550,
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003646'),
            content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003647'),
            okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000316'),
            onOk() {
              v.pageParamsStatus = true;
            }
          });
        }
      });
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  beforeDestroy() {
    EventBus.$off('initAbnormalStockingOfGoodsData', this.handleCustomerBillData);
  },
  components: {
    exportFieldsModal
  }
};
</script>

<style lang="less" scoped>

</style>
